import { Injectable } from '@angular/core';
import { TokenService } from '../Services/token.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  isSession(): Promise<boolean> {
    if (typeof Storage !== 'undefined') {
      const user = sessionStorage.getItem('User');

      if (user) {
        return Promise.resolve(true);
      }
    }

    return Promise.resolve(false);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CheckAuth {

  moonLanding!: Date;
  currentTime!: Date;

  constructor(private readonly tokenService: TokenService) { }

  GetToken(): void {
    this.tokenService.getAuthentication().subscribe(
      (t: any) => {

        this.moonLanding = new Date();

        sessionStorage.setItem('tokenValue', t.tokenDetail.token);
        sessionStorage.setItem('tokenExpiryValue', t.tokenDetail.tokenExpiry.toString());
        sessionStorage.setItem('appStartTime', this.moonLanding.toString());

        localStorage.setItem('tokenValue', t.tokenDetail.token);
        localStorage.setItem('tokenExpiryValue', t.tokenDetail.tokenExpiry.toString());
        localStorage.setItem('appStartTime', this.moonLanding.toString());
      },
      error => {
        console.error('Token authentication failed', error);
      }
    );
  }

  tokenExpireCalculation(startDate: string | null, tokenExpiry: string | null): void {

    if (startDate && tokenExpiry) {

      this.currentTime = new Date();

      let time =
        this.currentTime.getTime() -
        new Date(startDate).getTime();

      time = time / 1000;
      time = time / 60;
      time = Math.round(Math.abs(time));

      if (time > (parseInt(tokenExpiry, 10) - 2)) {
        this.GetToken();
      }
    } else {
      this.GetToken();
    }
  }
}